import React, { Component } from "react";

import Slider from "rc-slider";
import { LineInput } from "components/Inputs/LineInput";
import RangeSlider from "components/Inputs/Slider/RangeSlider";

import { Popover, OverlayTrigger } from "react-bootstrap";

import styles from "./style.module.css";

import { getColorFromId } from "utils/misc";

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

function convertFromPercentage(val) {
  return parseFloat(String(val).replace("%", "")) / 100;
}

function convertToPercentage(val) {
  return val * 100;
}

export default class CapSlider extends React.Component {
  allEqual(arr) {
    return arr.every((v) => v === arr[0]);
  }

  updateFrontierRange(min, max) {
    const { updateFrontierRange } = this.props;
    let retMin = convertFromPercentage(min);
    let retMax = convertFromPercentage(max);
    return updateFrontierRange([retMin, retMax]);
  }

  render() {
    const {
      impacts,
      isWizard,
      isCapacity,
      label,
      capModels,
      currentImpact,
      showLabels,
      drilldown,
      drilldownValue,
      updateDrilldownValue,
      onChange,
      otherColor,
      selectedColor,
      isEditFrontierRange,
      updateFrontierRange,
      frontierRange,
      hideHandle,
      isNext,
      isMonitoring,
      userThresholds,
      isOverallSegment
    } = this.props;

    let marks = {};
    let dataMap = {};
    impacts &&
      impacts.forEach((d, i) => {
        marks[Number(d.value)] =
          d.value === currentImpact ? (
            <div />
          ) : (
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div className={styles.popover}>
                    <div>{"Test"}</div>
                  </div>
                </Popover>
              }
            >
              <div className={styles.lineHolder} style={otherColor ? { background: otherColor } : {}}></div>
            </OverlayTrigger>
          );

        dataMap[Number(d.value)] = d;
      });

    const colorList = {};

    capModels &&
      Object.keys(capModels).forEach((c) => {
        const model = (capModels[c].model_data ? capModels[c].model_data : capModels[c]).id;
        if (colorList[model] === undefined) {
          colorList[model] = getColorFromId(model);
        }
      });

    if (impacts === undefined) {
      for (let i = 0; i < 100; i++) {
        marks[i] = <div />;
      }
    }

    const [rawFrontierMin, rawFrontierMax] = frontierRange || [0, 1];
    let frontierMin = convertToPercentage(rawFrontierMin);
    let frontierMax = convertToPercentage(rawFrontierMax);

    return (
      <div className={styles.impactSliderWrapper + " " + (isWizard ? styles.isWizard : "")}>
        {isWizard ? (
          ""
        ) : (
          <div className={styles.hShow} title={drilldownValue}>
            <div className={styles.aCircle} style={{ background: drilldown.color }} />
            {drilldownValue}
          </div>
        )}
        {isEditFrontierRange ? (
          <div className={styles.inputLine}>
            <LineInput
              min={0}
              max={100}
              onChange={(min) => this.updateFrontierRange(min, frontierMax)}
              value={frontierMin + "%"}
              isMediumBox
            />
          </div>
        ) : (
          ""
        )}
        <div className={styles.impactSlider}>
          <div className={styles.capWidth} style={{ width: isCapacity ? currentImpact + "%" : "0%" }} />
          <div className={styles.colorTest}>
            {capModels &&
              Object.keys(capModels).map((c, i) => (
                <div
                  value={i}
                  key={i}
                  style={{
                    height: "100%",
                    minWidth: 100 / 101 + "%",
                    background: capModels[c].color
                      ? capModels[c].color
                      : colorList[(capModels[c].model_data ? capModels[c].model_data : capModels[c]).id]
                  }}
                />
              ))}
          </div>
          <div className={styles.fHolds}>
            <div className={styles.sliderHolder}>
              {isMonitoring && isOverallSegment ? (
                <RangeSlider
                  hideInput
                  style={{ pointerEvents: onChange ? "all" : "none" }}
                  onChange={onChange ? onChange : () => {}}
                  min={0}
                  max={100}
                  step={0.01}
                  count={userThresholds?.length - 1}
                  // className={styles.sliderAbsolute}
                  trackStyle={{ opacity: 0, height: "5px" }}
                  railStyle={{
                    opacity: 0.7,
                    height: "5px",
                    background: "#F2F3F7"
                  }}
                  handleStyle={userThresholds.map((e, i) => {
                    return {
                      zIndex: 505 + i,
                      borderColor: "#FFFFFF",
                      boxShadow: "0px 0px 3px 1px rgba(81, 47, 119, 0.35)",

                      borderRadius: "2px",
                      borderWidth: "1px",
                      width: "6px",
                      height: "16px",
                      marginTop: "-5px",
                      backgroundColor: e?.color
                    };
                  })}
                  value={userThresholds?.map((e) => e?.threshold)}
                />
              ) : (
                <Slider
                  style={{ pointerEvents: onChange ? "all" : "none" }}
                  onChange={onChange ? onChange : () => {}}
                  min={onChange ? 0 : undefined}
                  max={onChange ? 100 : undefined}
                  marks={Object.keys(marks).length > 0 ? marks : undefined}
                  included={false}
                  step={onChange ? 100 : null}
                  trackStyle={{ backgroundColor: "transparent" }}
                  handleStyle={{
                    display: hideHandle ? "none" : undefined,
                    backgroundColor: isMonitoring
                      ? userThresholds?.[0]?.color
                      : selectedColor
                        ? selectedColor
                        : "#F47C20",
                    borderColor: "#FFFFFF",
                    boxShadow: "0px 0px 3px 1px rgba(81, 47, 119, 0.35)",

                    borderRadius: "2px",
                    borderWidth: "1px",
                    width: "6px",
                    height: "16px",
                    marginTop: "-5px",

                    zIndex: isWizard ? 1 : 501,
                    pointer: "cursor !important"
                  }}
                  value={isMonitoring ? userThresholds?.[0]?.threshold : currentImpact}
                />
              )}
              {isEditFrontierRange ? (
                <RangeSlider
                  hideInput
                  min={0}
                  max={100}
                  value={[frontierMin, frontierMax]}
                  onChange={([min, max] = []) => this.updateFrontierRange(min, max)}
                  step={1}
                  className={styles.sliderAbsolute}
                  trackStyle={{ opacity: 0.3, height: "5px" }}
                  railStyle={{
                    opacity: 0.7,
                    height: "5px",
                    background: "#F2F3F7"
                  }}
                  handleStyle={[
                    {
                      zIndex: 505,
                      borderRadius: "3px",
                      width: "8px",
                      height: "25px",
                      marginTop: "-10px"
                    },
                    {
                      zIndex: 505,
                      borderRadius: "3px",
                      width: "8px",
                      height: "25px",
                      marginTop: "-10px"
                    }
                  ]}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {isEditFrontierRange || (isNext && onChange) ? (
          <div className={styles.inputLine}>
            <LineInput
              min={0}
              max={100}
              onChange={(max) => (isNext && onChange ? onChange(max) : this.updateFrontierRange(frontierMin, max))}
              value={isNext && onChange ? currentImpact.toFixed(1) + "%" : frontierMax + "%"}
              isMediumBox
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
